import { BRAZILIAN_STATES } from '@/constants/brazilianStates'
import { validateCEP } from '@/utils/validation'
import { z } from 'zod'

// Error messages in Portuguese
const errorMessages = {
  required: 'Este campo é obrigatório',
  invalidEmail: 'Email inválido',
  invalidCEP: 'CEP inválido. Use o formato 00000-000',
  invalidPropertyCode: 'Código deve ter 3-10 caracteres alfanuméricos',
  minValue: (min: number) => `Valor deve ser maior que ${min}`,
  maxValue: (max: number) => `Valor deve ser menor que ${max}`,
  minLength: (min: number) => `Deve ter pelo menos ${min} caracteres`,
  maxLength: (max: number) => `Deve ter no máximo ${max} caracteres`,
}

// Step 1: Basic Information (Required)
export const staysPropertySchema = z.object({
  _idtype: z.string().min(3, errorMessages.required),

  internalname: z
    .string()
    .min(3, errorMessages.required)
    .transform((internalname) => internalname.toUpperCase()),

  _mstitle: z.string().min(3, errorMessages.required),

  address: z.object({
    countryCode: z.string().default('BR'),
    stateCode: z.enum(
      BRAZILIAN_STATES.map((s) => s.value) as [string, ...string[]],
      {
        errorMap: () => ({ message: 'Selecione um estado válido' }),
      }
    ),
    city: z.string().min(3, errorMessages.required),
    region: z.string().min(3, errorMessages.required),
    street: z.string().min(3, errorMessages.required),
    streetNumber: z.string().min(1, errorMessages.required),
    zip: z
      .string()
      .min(1, errorMessages.required)
      .refine(validateCEP, errorMessages.invalidCEP),
  }),

  _msdesc: z.string().optional(),

  images: z.array(
    z.object({
      url: z.string(),
      is_primary: z.boolean().nullable(),
      stays_id: z.string().uuid().nullable(),
      file: z.instanceof(File).optional(), // For new uploads
    })
  ),
  status: z.enum(['active', 'inactive', 'draft', 'hidden']).default('draft'),
})

export type StaysPropertyFormInput = z.input<typeof staysPropertySchema>
export type StaysPropertyFormOutput = z.output<typeof staysPropertySchema>
